/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { theme } from "@nordcloud/gnui";

const ROW_CELL_CSS = {
  height: "2.5rem",
  paddingTop: theme.spacing.spacing00,
  paddingBottom: theme.spacing.spacing00,
  verticalAlign: "middle",
} as const;

export const iconCellCss = {
  "&&": {
    ...ROW_CELL_CSS,
    width: "1%",
    whiteSpace: "nowrap",
    paddingRight: theme.spacing.spacing00,
  },
} as const;

export const nameCellCss = {
  "&&": ROW_CELL_CSS,
  width: "100%",
} as const;

export const countCellCss = {
  "&&": ROW_CELL_CSS,
} as const;
